<template>
  <div class>
    <drawer
      :title="addEditTitle"
      :dialogShow="addEditShow"
      @handleChange="handleChangeDrawer"
    >
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            class="demo-ruleForm"
            label-width="170px"
            label-position="left"
          >
            <div class="align-items">
              <p class="order-title-boxs">
                <span class="blueBlock"></span><i>顾客信息</i>
              </p>
              <span @click="handMember" class="jishi fontSize16 pr16 cur" v-if="this.sourceFrom != 'order'">选择会员(可选)</span
              >
            </div>
            <div class="memberInfo" v-show="memberFlag">
              <member
                ref="member"
                :mobile="formMobile"
                @handleUser="memberChange"
              ></member>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="顾客姓名："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input
                    v-model.trim="form.customerName"
                    :disabled="disabledName"
                    placeholder="请输入顾客姓名"
                    maxlength="10"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="手机号："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input
                    v-model.trim="form.mobile"
                    :disabled="disabled"
                    placeholder="请输入手机号码"
                    @blur="numberEnter"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="单据状态："
                  prop="手工录入"
                  >
                  <el-input
                    v-model="depositTypeName"
                    :disabled="true"
                    placeholder="手工录入"
                  ></el-input>
                  </el-form-item
                > 
              </el-col>
            </el-row>
            <el-row>
              <div class="plr16 staff-boxs mt20">
                <div class="right-content space-between">
                  <span class="staff-btn mr10" >寄存技师</span>
                  <span class="jishi cur" @click="setStaff('item', 0)">{{staffIdNames ? staffIdNames : "请选择"}}></span>
                </div>
              </div>
            </el-row>

            <el-row class="pt10">
              <el-col :span="24">
                <el-form-item
                  label="备注："
                  required=""
                  class="el-form-item-update"
                >
                  <el-input
                    v-model="form.remark"
                    type="textarea"
                    placeholder="请输入备注"
                    maxlength="50"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
        <div class="align-items">
          <p class="order-title-boxs">
            <span class="blueBlock"></span><i>寄存明细</i>
          </p>
          <span class="jishi fontSize16 pr16 cur" @click="seletGift" v-if="this.sourceFrom != 'order'">选择产品</span
          >
        </div>
        <div class="contents-body" v-if="selectList.length != 0 && this.sourceFrom != 'order'">
          <el-row class="tables-title">
            <el-col :span="12" class="titles pl10">商品名称</el-col>
            <el-col :span="6" class="titles center">单价(元)</el-col>
            <el-col :span="4" class="titles center">寄存数量</el-col>
            <el-col :span="2" class="titles center">操作</el-col>
          </el-row>
          <div class="tables p30 scroll-auto">
            <div class="boxs" v-for="(item, index) in selectList" :key="index">
              <el-row>
                <el-col :span="12" class="titles pl10">{{ item.name }}</el-col>
                <el-col :span="6" class="money center">
                  ￥{{ item.salePrice }}
                </el-col>
                <el-col :span="4" class="nums center">
                  <span class="del-img" @click="blurItem('del', item)">
                    <img src="../../../assets/images/new/del.png" alt="" />
                  </span>
                  <el-input
                    v-model="item.itemNum"
                    readonly=""
                    size="mini"
                    style="width: 40px;"
                  ></el-input>
                  <span class="del-img" @click="blurItem('add', item)">
                    <img src="../../../assets/images/new/add.png" alt="" />
                  </span>
                </el-col>
                <el-col :span="2" class="detail right">
                  <i
                    class="el-icon-delete delete"
                    @click="deleteListSelected(item, index)"
                  ></i>
                </el-col>
              </el-row>
              <div class="right-content p10">
                <span class="staff-btn mr10 pl10">过期时间</span>
                <el-date-picker
                    v-model="item.expireTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                    popper-class="el-date-picker"
                    class="w200"
                  >
                  </el-date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="contents-body" v-else-if="selectList.length != 0">
                <el-row class="tables-title">
                  <el-col :span="10" class="titles pl10">商品名称</el-col>
                  <el-col :span="4" class="titles center">单价(元)</el-col>
                  <el-col :span="4" class="titles center">寄存数量</el-col>
                  <el-col :span="6" class="titles center">过期时间</el-col>
                </el-row>
                <div class="order-scoll">
                  <el-row v-for="(item,index) in selectList" :key="index" class="ml20 mr20 ptb20 borderB">
                    <div class="align-item">
                      <div class="mr10" @click="onClick(item)">
                        <img src="../../../assets/images/new/order_orderrefund_unchecked.png" alt="" v-if="item.count == 0">
                        <img src="../../../assets/images/new/orderrefund_unchecked.png" alt="" v-else-if="!item.isSelected">
                        <img src="../../../assets/images/new/order_orderrefund_select.png" alt="" v-else-if="item.isSelected">
                      </div>
                      <div class="w100b align-items">
                        <el-col :span="10" class="pl10" :class="[item.itemNum == 0 ? 'color999':'']">{{item.name}}</el-col>
                        <el-col :span="4" class="color999">￥{{ item.salePrice }}</el-col>
                        <el-col :span="4" class="nums center">
                          <span class="del-img" @click="blurItem('del', item)">
                            <img src="../../../assets/images/new/del.png" alt="" />
                          </span>
                          <el-input
                            v-model="item.itemNum"
                            readonly=""
                            size="mini"
                            style="width: 40px;"
                          ></el-input>
                          <span class="del-img" @click="blurItem('add', item)">
                            <img src="../../../assets/images/new/add.png" alt="" />
                          </span>
                        </el-col>
                        <el-col :span="6" class="color999 pl10 pr10">
                          <el-date-picker
                            v-model="item.expireTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期"
                            :disabled="item.count == 0"
                            popper-class="el-date-picker"
                            class="w100"
                          ></el-date-picker>
                        </el-col>
                      </div>
                    </div>
                  </el-row>
                </div>
              </div>

        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" class="ml10" @click="save"
              >确定寄存</el-button
            >
          </div>
        </div>
      </div>
    </drawer>
    <selectGift ref="selectGift" @changeGift="giftCallback"></selectGift>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import member from "../../components/member";
import selectGift from "./selectGift.vue"
import staffSet from "../../components/staff-set";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { drawer ,member, selectGift , staffSet},
  data() {
    return {
      sourceFrom: "",//order
      addEditTitle: "添加寄存",
      addEditShow: false,
      options: [],
      depositTypeName: "手动录入",
      form: {
        memberId: "",
        customerName: "",
        mobile: "",
        depositType: "manual",
        staffIds: "",
        staffNames: "",
        remark: "",
        orderId: "",
        itemList: [],

        // itemId: "",
        // itemName: "",
        // salePrice: "",
        // unit: "",
        // itemNum:"",
        // expireTime: "",
      },
      formMobile: "",
      memberFlag: false,
      selectList: [],
      staffIndex: null,
      disabled: false,
      disabledName: false,
      staffList: [],

      staffIds: {},
      staffIdNames: "",
      fisrtName: [],

      availableInfo: {},
      selectedArrayList: [],//从订单进来选中后的
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.$refs["member"].clearMember();
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditTitle = "添加寄存";
        this.addEditShow = true;
        this.cardOldList();

        if (org.sourceFrom == 'order') {
          this.disabledName = true;
          this.disabled = true;
          this.depositTypeName = "订单转存";
          this.sourceFrom = org.sourceFrom;
          this.form.orderId = org.orderId;
          this.$api
            .get(this.$url.report.availableInfo, {
              orderId: org.orderId,
            })
            .then((res) => {
              if (res) {
                this.availableInfo = res;
                this.form.memberId = this.availableInfo.memberId;
                this.form.customerName = this.availableInfo.customerName;
                this.form.mobile = this.availableInfo.mobile;
                if (this.form.memberId) {
                  this.disabledName = true;
                  this.disabled = true;
                }else {
                  this.disabledName = false;
                  this.disabled = false;
                  this.form.customerName = "";
                }

                this.availableInfo.itemList.map((item) => {
                  item.name = item.itemName;
                  this.$set(item, "itemNum", item.itemNum ? item.itemNum : 0);
                  this.$set(item, "isSelected", false);
                  this.$set(item, "count", item.itemNum);
                });
                this.selectList = this.availableInfo.itemList;
              }
            });
        }
      });
    },
    cardOldList() {
      this.$api
        .get(this.$url.companyStaff.list, {filterStatus: 'disable'})
        .then(res => {
          if (res) {
            this.staffList = res;
          }
        })
        .catch(error => {});
    },
    memberChange(value) {
      this.form.memberId = value.id;
      this.form.customerName = value.realName;
      this.form.idCardNo = value.idCardNo;
      this.form.mobile = value.mobile;
      console.log(this.form);
      if (this.form.memberId) {
        this.disabledName = true;
      } else {
        this.disabledName = false;
      }
      if (this.form.mobile && !this.form.idCardNo) {
        this.disabled = true;
      } else if (this.form.idCardNo && !this.form.mobile) {
        this.disabled = false;
      } else if (this.form.mobile && this.form.idCardNo) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      this.memberFlag = false;
    },
    handMember() {
      // 选择会员
      this.memberFlag = true;
      if (this.form.memberId) {
        this.$refs["member"].clearMember();
        this.form = {};
        this.disabledName = false;
        this.disabled = false;
      }
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: this.fisrtName,
        index: index
      });
    },
    changePage(org) {
         // 选择技师 -- 回调
        if (org) {
            let id = [];
            let name = []
            console.log(org, '---------');
            this.fisrtName = org.staffIds;
            org.staffIds.map(item => {
                id.push(item.staffId);
                name.push(item.staffName)
            })

            id = id.join(",")
            name = name.join(",")
            this.staffIdNames = name;
            this.$set(this.staffIds, 'staffIds', id)
            this.form.staffIds = id;
            this.form.staffNames = name;
        }
    },
    seletGift() {
      // 选择赠品
      this.$refs["selectGift"].$emit("set", this.selectList);
    },
    giftCallback(org) {
      // 选择赠品回调函数
      console.log(org);
      if (org) this.selectList = this.selectList.concat(org);
      this.selectList.map((item) => {
        item.itemId = item.id;
        item.itemName = item.name;
        this.$set(item, "itemNum", item.itemNum ? item.itemNum : 1);
        // item.itemNum = item.itemNum ? item.itemNum : 0
      });
      console.log(this.selectList);
    },
    // 失去焦点的时候 数量变为1
    blurItem(type, item) {
      if (type == "del") {
        if (item.itemNum > 1) item.itemNum--;
      } else {
        if (item.itemNum >= item.count) return;
        item.itemNum++;
      }
      // this.handleChangeInput();
    },
    // blurItem (item) {
    //   if (!item.itemNum) {
    //     item.itemNum = Number(1)
    //     this.handleChangeInput();
    //   }
    // },
    deleteListSelected(item, index) {
      item.itemNum = Number(1);
      this.selectList.splice(index, 1);
    },
    handleChangeDrawer() {
      this.$refs['member'].clearMember();
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    numberEnter() {
      // var re = /^1[3456789]\d{9}$/;
      // if (!re.test(this.form.mobile)) {
      //     this.$message.error("请输入正确的手机号码")
      // }
      if (this.form.mobile && this.form.mobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
      }
    },
    onClick(item,index) {
      if (item.count == 0) {
        return;
      }
      item.isSelected = !item.isSelected;
      console.log(item.isSelected);
      this.$set(item, 'isSelected', item.isSelected);

      if (item.isSelected) {
        this.selectedArrayList.push(item);
      }else {
        this.selectedArrayList.splice(index,1);
      }
    },
    save() {
      // var re = /^1[3456789]\d{9}$/;
      console.log(!this.form.mobile && !this.disabled && !this.form.idCardNo);
      if (!this.form.customerName) {
        return this.$message.error("请输入顾客姓名");
      } else if (!this.form.mobile && !this.disabled && !this.form.idCardNo) {
        return this.$message.error("请输入手机号码");
      } else if (this.form.mobile && this.form.mobile.length != 11) {
        return this.$message.error("请输入正确的手机号码");
      } else if (!this.form.staffIds) {
        return this.$message.error("请选择技师");
      } else if (!this.form.remark) {
        return this.$message.error("请输入备注");
      } else if (this.selectList.length == 0) {
        return this.$message.error("请选择产品");
      }

      if (this.sourceFrom == 'order') {
        if (this.selectedArrayList.length == 0) {
          return this.$message.error("请选择寄存产品");
        }
        for (let i = 0; i < this.selectedArrayList.length; i++) {
          if (this.selectedArrayList[i].isSelected) {
            if (!this.selectedArrayList[i].expireTime) {
              console.log("这个"+this.selectedArrayList[i].isSelected);
              return this.$message.error("请选择过期时间");
            }
          }
        }
      }else {
        for (let i = 0; i < this.selectList.length; i++) {
          if (!this.selectList[i].expireTime) {
            console.log("不进来这里");
            return this.$message.error("请选择过期时间");
          }
        }
      }

      this.staffList.map((item) => {
        if (this.form.staffIds == item.id) {
            this.form.staffNames = item.staffName;
        }
      });

      if (this.sourceFrom == 'order') {
        this.form.itemList = this.selectedArrayList;
      }else {
        this.form.itemList = this.selectList;
      }

      if (this.sourceFrom == 'order') {
        this.form.depositType = 'order';
      }else {
        this.form.depositType = 'manual';
      }

      let arr = encrypt(JSON.stringify(this.form));
      this.$api
        .post(this.$url.report.depositInfoSave, arr)
        .then((res) => {
          if (res) {
            this.addEditShow = false;
            this.selectList = [];
            this.selectedArrayList = [];
            this.$refs["member"].clearMember();
            this.$message.success("寄存成功");
            this.$emit("change", true);
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.contents-body {
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .tables-title {
    font-size: 14px;
    margin: 0 16px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 600;
    background: #f7f8fa;
  }
  .tables {
    padding: 0 16px 0;
    max-height: 150px;
    box-sizing: border-box;
    .boxs {
      min-height: 65px;
      padding: 24px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      .titles {
        font-weight: 500;
      }
      .money {
        color: @money;
        font-weight: 500;
      }
      .nums {
        /deep/.el-input-number {
          width: 80px;
          .el-input__inner {
            padding: 0 25px;
            height: 22px;
            line-height: 22px;
          }
        }
      }
      .delete {
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: @blue;
        }
      }
    }
    .right-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .staff-btn {
        display: inline-block;
        text-align: center;
        color: #111;
      }
    }
  }
}

.order-scoll {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

.memberInfo {
  padding: 0 20px;
}
.pay-mains {
  padding: 0;
  overflow: hidden;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
</style>
